var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.714c-2.374 0-4.644 1.37-6.83 4.286 2.186 2.917 4.456 4.286 6.83 4.286 2.374 0 4.645-1.37 6.83-4.286-2.186-2.917-4.456-4.286-6.83-4.286ZM10 13c-3.314 0-6.314-2-9-6 2.686-4 5.686-6 9-6s6.314 2 9 6c-2.686 4-5.686 6-9 6Zm0-4.286c.994 0 1.8-.767 1.8-1.714s-.806-1.714-1.8-1.714S8.2 6.053 8.2 7s.806 1.714 1.8 1.714Zm0 1.715c-1.988 0-3.6-1.535-3.6-3.429S8.012 3.571 10 3.571s3.6 1.535 3.6 3.43c0 1.893-1.612 3.428-3.6 3.428Z",
    fill: "currentColor",
    stroke: "#fff",
    strokeWidth: 0.4
  })));
};
export default SvgEye;